import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import "amfe-flexible/index.js";
import store from "./store";
Vue.config.productionTip = false;
import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'gH7hIADk7WjYpTlHB398HiYlFN9l4ds5'
})

// 我们在main.js中用常量创建一个bus，然后将它放入Vue实例的原型对象中。
const bus = new Vue()
Vue.prototype.$bus = bus;

import Vant from 'vant';
import 'vant/lib/index.css';
import './assets/font/iconfont/iconfont.css'

import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import wsConnection from './utils/socket'
Vue.prototype.$setWs = wsConnection;

Vue.use(elementUI)

Vue.use(Vant);
//自定义指令
import Directives from '@/directive/copy/index.js';
Vue.use(Directives);

import vueMiniPlayer from 'vue-mini-player'
import 'vue-mini-player/lib/vue-mini-player.css'
Vue.use(vueMiniPlayer)

import "vant/lib/index.css";
import Vconsole from "vconsole";
//开发环境使用，生产环境自动取消
if (process.env.NODE_ENV == "development") {
  new Vconsole();
}
// new Vconsole();
new Vue({
  router, store,
  render: (h) => h(App),
}).$mount("#app");
